$(document).ready(function() {
  if ($.fn.slick) {
    $(".events__slider-body").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      prevArrow: $('.events__slider-prev'),
      nextArrow: $('.events__slider-next')
    });
  }
});
